import logo from '@/assets/images/hello-refi-logo.svg';
import { LogoWrapper } from './sidebarHeader.styles.ts';

const SidebarHeader = () => {
  return (
    <LogoWrapper>
      <img
        src={logo}
        alt="hello-refi-logo"
      />
    </LogoWrapper>
  );
};

export default SidebarHeader;
